import * as React from 'react';
import {Carousel} from './carousel';
import {style} from 'typestyle';
import {TrackTile} from './track-tile';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {percent, px, rem, viewWidth} from 'csx';
import {colorBrand, colorSlate, colorWhite} from '../theme/color';
import {TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';
import {constantHeaderHeight} from '../theme/constant';

export interface AppJustAddedProps {
  tracks: Array<TrackSchema>;
  onClickLink(event: React.MouseEvent<any>): void;
  preload: ImagePreloader;
  PlayButton: any;
  AddRemove: any;
  Favourite: any;
  i18n?: {
    title: string;
  }
}

const DEFAULT_I18N = {
  title: 'Just added'
};

export class AppJustAdded extends React.Component<AppJustAddedProps, any> {
  render() {
    const { i18n = DEFAULT_I18N, tracks = [], PlayButton, Favourite, AddRemove, onClickLink, preload } = this.props;

    return (
      <div className={AppJustAdded.styles.container}>
        <h4>{i18n.title}</h4>
        <Carousel className={AppJustAdded.styles.carousel}>
          {tracks.map((track, index) => (
            <TrackTile
              key={index}
              track={track}
              PlayButton={PlayButton}
              AddRemove={AddRemove}
              Favourite={Favourite}
              onClickLink={onClickLink}
              preload={preload}
              className={AppJustAdded.styles.track}
            />
          ))}
        </Carousel>
      </div>
    )
  }

  static mobileSize = viewWidth(85);
  static desktopSize = viewWidth(18);

  static styles = {
    container: style({
      zIndex: 1,
      background: colorSlate.darken(0.05).toString(),
      width: percent(100),
      $nest: {
        '&> h4': {
          fontSize: px(22),
          margin: 0,
          lineHeight: constantHeaderHeight,
          height: constantHeaderHeight,
          padding: '0 16px',
          color: colorWhite.toString(),
          background: colorBrand.toString()
        }
      }
    }),
    carousel: style(
      { minHeight: rem(12), maxHeight: rem(18) },
      mediaMobileOnly({ height: AppJustAdded.mobileSize }),
      mediaTablet({ height: AppJustAdded.desktopSize })
    ),
    track: style(
      { height: 'auto !important', minWidth: rem(12), maxWidth: rem(18) },
      mediaMobileOnly({ width: AppJustAdded.mobileSize }),
      mediaTablet({ width: AppJustAdded.desktopSize })
    )
  }
}